export default {
	general: {
		save: 'Tallenna',
		cancel: 'Peruuta',
		yes: 'Kyllä',
		no: 'Ei',
		goBack: 'Palaa takaisin',
		changeCookieSettings: 'Muuta evästeasetuksiasi',
	},
	routes: {
		error404: {
			title: 'Sivua ei löytynyt',
		},
		membershipCard: {
			title: 'Kortti',
		},
		memberDetails: {
			title: 'Jäsentiedot',
			headline: 'Jäsentiedot',
		},
		benefitContainer: {
			title: 'Jäsenedut',
			headline: 'Jäsenedut',
		},
		benefit: {
			title: 'Jäsenetu',
			headline: 'Jäsenetu',
		},
		eventContainer: {
			title: 'Tapahtumat',
			headline: 'Tapahtumat',
		},
		event: {
			title: 'Tapahtuma',
			headline: 'Tapahtuma',
		},
		newsContainer: {
			title: 'Uutiset',
			headline: 'Uutiset',
		},
		news: {
			title: 'Uutinen',
			headline: 'Uutinen',
		},
		pageContainer: {
			title: 'Sivut',
			headline: 'Sivut',
		},
		page: {
			title: 'Sivu',
			headline: 'Sivu',
		},
		invoiceContainer: {
			title: 'Laskut',
			headline: 'Laskut',
		},
		invoice: {
			title: 'Lasku',
			headline: 'Lasku',
		},
		settings: {
			title: 'Asetukset',
			headline: 'Asetukset',
		},
		formPageContainer: {
			title: 'Lomakkeet',
			headline: 'Lomakkeet',
		},
		clubContainer: {
			title: 'Kerhot',
			headline: 'Kerhot',
		},
		assignmentContainer: {
			title: 'Tehtävät',
			headline: 'Tehtävät',
		},
		companyContainer: {
			title: '4H-yritykset',
			headline: '4H-yritykset',
		},
	},
	cookieTypes: {
		necessary: 'Välttämättömät',
		statistics: 'Tilastointi',
		marketing: 'Markkinointi',
	},
	validationErrors: {
		required: 'Tämä kenttä on pakollinen.',
		email: 'Tarkista sähköpostiosoitteen muotoilu.',
		turnover: 'Luvun on oltava väliltä 50–8000.',
		sum: 'Luvun on oltava desimaaliluku',
		nonNegative: 'Luvun on oltava 0 tai suurempi.',
	},
}
